// @spec DHB-STR-007
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { QualityDashboardPage } from '@/features/datahub/components/QualityDashboardPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/quality-dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.dataQuality'),
  }),
  component: QualityDashboardPage,
});
